/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Markup_LabelInputs */

const cs_templates_ai_markup_label = /** @type {(inputs: Templates_Ai_Markup_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown nebo HTML`)
};

const en_templates_ai_markup_label = /** @type {(inputs: Templates_Ai_Markup_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown or HTML`)
};

/**
* | output |
* | --- |
* | "Markdown or HTML" |
*
* @param {Templates_Ai_Markup_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_markup_label = /** @type {((inputs?: Templates_Ai_Markup_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Markup_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_markup_label(inputs)
	return cs_templates_ai_markup_label(inputs)
});